import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import get from 'lodash/get';
import { Typography, useTheme, Icons } from '@hmsexp/component-library';
import { tableCellStyles } from '../Table/styles';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { underscoreToText } from '../../../containers/OnlineReview/utils';

const GraphTableCell = ({ column, isHeaderCell, sample_size_data, lowSampleSize, index, row, sortColumns, nestingLevel }) => {
  const theme = useTheme();
  const styles = tableCellStyles(theme);
  if (isHeaderCell) {
    const label = get(column, 'label', '').toUpperCase();
    const field = get(column, 'field', '');
    return (
      <View style={[styles.headerWrap, index === 0 && styles.firstColumn]}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4
          }}>
          <Typography variant='caption' fontWeightType='semiBold'>
            {label}
          </Typography>

          {sortColumns.includes(field) && (
            <TouchableOpacity style={{ marginLeft: 4, marginRight: 8 }}>
              <Icons.ChevronUp size='XS' color='primaryContentMedium' />
              <Icons.ChevronDown size='XS' color='primaryContentMedium' />
            </TouchableOpacity>
          )}
        </View>
      </View>
    );
  }

  const field = get(column, 'field', '');
  const value = get(row, field, '-');

  if (nestingLevel === 1) {
    if (index === 0) {
      return (
        <View
          style={{
            paddingVertical: 12
          }}>
          <HighchartsReact highcharts={Highcharts} options={value?.chart_options} />
        </View>
      );
    } else return null;
  }
  const sampleSizeValue = sample_size_data?.[row?.index]?.[column?.field]

  const isLowSampleSize = Number.isFinite(sampleSizeValue) && sampleSizeValue < lowSampleSize;
  return (
    <View style={[styles.rowWrap, index === 0 && styles.firstColumn]}>
      {isLowSampleSize && <div
        style={{
          position: 'relative',
          width: 12,
          height: 12,
          borderRadius: '50%',
          border: '1.5px solid #D32F2F',
          overflow: 'hidden',
          flexShrink: 0
        }}>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '50%',
            backgroundColor: '#D32F2F'
          }}
        />
      </div>}
      <Typography variant='caption' fontWeightType='regular'
        textProps={{ style: { color: isLowSampleSize ? "#D32F2F" : "black" } }}
      >
        {underscoreToText(String(value))}
      </Typography>
    </View>
  );
};

export default GraphTableCell;
